/* Quote modal on the product page. Everything here enhances server-rendered
   markup: the triggers are links to the quote page and the modal holds a
   normal contact form that posts without JS.

   - A click on any [data-quote-open] inside the product section opens the
     <dialog>: the part-number field takes data-quote-sku (else the page
     sku), the quantity copies the buy box stepper for the page part (else 1).
   - [data-quote-close] and a click on the backdrop close it; Esc is native.
   - data-quote-state="success" | "error" (written by Liquid after a post)
     opens the dialog on load; on success the contact_posted flag is removed
     from the URL so a reload does not reopen it.
   - Without dialog.showModal nothing is intercepted: the links follow their
     href to the quote page. The scroll lock is CSS (scroll-lock attribute,
     html:has(dialog[scroll-lock][open]) in critical.css). */
(function () {
  'use strict';

  var dialog = document.querySelector('[data-quote-modal]');
  if (!dialog) return;

  var state = dialog.getAttribute('data-quote-state') || '';
  var posted = state === 'success' || state === 'error';

  if (typeof dialog.showModal !== 'function') {
    /* No <dialog> support: a posted state is still shown in the flow. */
    if (posted) dialog.setAttribute('open', '');
    return;
  }

  var productRoot = document.querySelector('[data-product]');
  var section = (productRoot && productRoot.closest('.shopify-section')) || document;
  var partField = dialog.querySelector('[data-quote-part]');
  var qtyField = dialog.querySelector('[data-quote-qty]');
  var productLine = dialog.querySelector('[data-quote-product]');
  var pageSku = (dialog.getAttribute('data-quote-page-sku') || (partField ? partField.defaultValue : '') || '').trim();
  var lastTrigger = null;
  var pressedBackdrop = false;

  function focusElement(el) {
    if (!el || typeof el.focus !== 'function') return;
    try {
      el.focus({ preventScroll: true });
    } catch (error) {
      el.focus();
    }
  }

  function firstEditable() {
    return dialog.querySelector(
      'input:not([type="hidden"]):not([readonly]):not([disabled]), select:not([disabled]), textarea:not([disabled])'
    );
  }

  /* Part number and quantity for the requested part. The buy box quantity
     is copied only when the request is for the page part. */
  function prefill(sku) {
    var requested = (sku || '').trim() || pageSku;
    var samePart = requested === pageSku;
    if (partField) partField.value = requested;
    if (qtyField) {
      var qty = 1;
      if (samePart) {
        var qtyInput = section.querySelector('[data-qty-input]');
        var parsed = qtyInput ? parseInt(qtyInput.value, 10) : NaN;
        if (parsed > 0) qty = parsed;
      }
      qtyField.value = String(qty);
    }
    if (productLine) productLine.hidden = !samePart;
  }

  function open(trigger) {
    lastTrigger = trigger || null;
    prefill(trigger ? trigger.getAttribute('data-quote-sku') : '');
    if (!dialog.open) dialog.showModal();
    focusElement(firstEditable() || dialog.querySelector('[data-quote-close]'));
  }

  function close() {
    if (dialog.open) dialog.close();
  }

  /* Triggers (buy box, strip, mobile bar, ladder and related rows). Modified
     clicks keep the browser behaviour (open in a new tab). */
  section.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;
    var trigger = target.closest('[data-quote-open]');
    if (!trigger || dialog.contains(trigger)) return;
    if (event.defaultPrevented || event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    open(trigger);
  });

  /* Close: buttons, and a click that starts and ends on the backdrop (the
     dialog element itself; its children cover the whole panel). */
  dialog.addEventListener('pointerdown', function (event) {
    pressedBackdrop = event.target === dialog;
  });

  dialog.addEventListener('click', function (event) {
    var target = event.target;
    if (target && typeof target.closest === 'function' && target.closest('[data-quote-close]')) {
      close();
      return;
    }
    if (target === dialog && pressedBackdrop) close();
    pressedBackdrop = false;
  });

  dialog.addEventListener('close', function () {
    pressedBackdrop = false;
    if (lastTrigger && document.contains(lastTrigger)) focusElement(lastTrigger);
    lastTrigger = null;
  });

  /* Shopify's storefront spam protection binds the contact form and, when it
     challenges the visitor, appends the hCaptcha challenge frame to <body>.
     A modal <dialog> sits in the top layer and would cover it, so the dialog
     is closed as soon as a visible challenge frame appears; the captcha
     script then submits the form itself and the posted page reopens the
     dialog in its success or error state. */
  /* Opacity is not tested: the challenge fades in from opacity 0 with a CSS
     transition, which emits no mutation record. */
  function nodeShown(node) {
    while (node && node !== document.body) {
      var style = window.getComputedStyle(node);
      if (style.visibility === 'hidden' || style.display === 'none') return false;
      node = node.parentElement;
    }
    return true;
  }

  /* The captcha script parks a hidden challenge frame off-screen as soon as it
     binds the form; only a frame that is shown inside the viewport counts. */
  function challengeVisible() {
    var frames = document.querySelectorAll('iframe[src*="hcaptcha"][src*="frame=challenge"]');
    for (var i = 0; i < frames.length; i += 1) {
      var rect = frames[i].getBoundingClientRect();
      if (rect.width <= 0 || rect.height <= 0) continue;
      if (rect.bottom <= 0 || rect.right <= 0) continue;
      if (rect.top >= window.innerHeight || rect.left >= window.innerWidth) continue;
      if (nodeShown(frames[i])) return true;
    }
    return false;
  }

  /* The challenge is shown through style changes followed by a transition, so
     every mutation is re-checked once more a moment later. */
  function yieldToChallenge() {
    if (dialog.open && challengeVisible()) close();
  }

  /* The challenge, when it comes, appears about half a second after submit. */
  var form = dialog.querySelector('form');
  if (form) {
    form.addEventListener('submit', function () {
      [600, 1200, 2000, 3000].forEach(function (delay) {
        setTimeout(yieldToChallenge, delay);
      });
    });
  }

  var recheckTimer = null;
  if (window.MutationObserver) {
    var watcher = new MutationObserver(function () {
      if (!dialog.open) return;
      yieldToChallenge();
      clearTimeout(recheckTimer);
      recheckTimer = setTimeout(yieldToChallenge, 400);
    });
    watcher.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class'] });
  }

  /* After a post: reopen with the success panel or the error list. */
  function stripPostedFlag() {
    if (!window.history || typeof history.replaceState !== 'function' || typeof URL !== 'function') return;
    try {
      var url = new URL(window.location.href);
      if (!url.searchParams.has('contact_posted')) return;
      url.searchParams.delete('contact_posted');
      history.replaceState(history.state, '', url.pathname + url.search);
    } catch (error) {
      /* The URL stays as it is. */
    }
  }

  if (posted) {
    if (productLine) productLine.hidden = false;
    if (!dialog.open) dialog.showModal();
    if (state === 'success') {
      stripPostedFlag();
      focusElement(dialog.querySelector('.quote-modal__success [data-quote-close]') || dialog.querySelector('[data-quote-close]'));
    } else {
      focusElement(firstEditable() || dialog.querySelector('[data-quote-close]'));
    }
  }
})();
